import type { ValidateSessionStatus } from '../types/validateDetails.types';

// ─── Session status maps ───────────────────────────────────────────────────────

export const SESSION_STATUS_LABEL: Record<ValidateSessionStatus, string> = {
  RUNNING:   'Running',
  COMPLETED: 'Completed',
  SCHEDULED: 'Scheduled',
  FAILED:    'Failed',
  DEPLOYING: 'Deploying',
};

export const SESSION_STATUS_CSS: Record<ValidateSessionStatus, string> = {
  RUNNING:   'running',
  COMPLETED: 'complete',
  SCHEDULED: 'scheduled',
  FAILED:    'failed',
  DEPLOYING: 'deploying',
};

// ─── Header satellite select styles ──────────────────────────────────────────
// Note: CustomSelect prop spelling is `controllHeight` (kept as-is for compat).

export const VALIDATE_HEADER_SELECT = {
  controlHeight: '34px',
  padding:       '0 2px 0 24px',
  border:        'none',
  background:    'transparent',
  color:         'rgba(240, 240, 240, 0.9)',
} as const;

// ─── Form field constraints ───────────────────────────────────────────────────

/** Max characters for a setup name. */
export const SETUP_NAME_MAX_LEN = 26;

/** Max characters for a setup description. */
export const SETUP_DESCRIPTION_MAX_LEN = 200;

/** Max characters for a session name. */
export const SESSION_NAME_MAX_LEN = 26;

/** Max characters for a session team name. */
export const SESSION_TEAM_MAX_LEN = 26;

/** Minimum ms between repeated character-limit toast messages. */
export const CHAR_LIMIT_TOAST_COOLDOWN_MS = 1_200;
